// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Css = require("../design-system/particle/Particle_Css.bs.js");

var zeroSize = Particle_Css.spacerSizeToString("Zero");

var noneSize = Particle_Css.spacerSizeToString("None");

var xxsSize = Particle_Css.spacerSizeToString("XXS");

var xsSize = Particle_Css.spacerSizeToString("XS");

var sSize = Particle_Css.spacerSizeToString("S");

var mSize = Particle_Css.spacerSizeToString("M");

var lSize = Particle_Css.spacerSizeToString("L");

var xlSize = Particle_Css.spacerSizeToString("XL");

var sizes = {
  Zero: zeroSize,
  None: noneSize,
  XXS: xxsSize,
  XS: xsSize,
  S: sSize,
  M: mSize,
  L: lSize,
  XL: xlSize
};

exports.zeroSize = zeroSize;
exports.noneSize = noneSize;
exports.xxsSize = xxsSize;
exports.xsSize = xsSize;
exports.sSize = sSize;
exports.mSize = mSize;
exports.lSize = lSize;
exports.xlSize = xlSize;
exports.sizes = sizes;
/* zeroSize Not a pure module */
